import _isEmpty from 'lodash/isEmpty';
import _keyBy from 'lodash/keyBy';
import _map from 'lodash/map';
import { getTypeNameBySpan } from '../components/Visualizer/utils';

function validateGridSpan(normalizedMetadata) {
  if (!_isEmpty(normalizedMetadata) && normalizedMetadata?.GridSpan) {
    return normalizedMetadata.GridSpan.value.split(',').map(Number);
  }
  return [0, 0, 0];
}

export default (choices) => {
  const choicesVisualizerInfo = _map(choices, (choice) => {
    const normalizedMetadata = _keyBy(choice.metaDataItems, 'name');
    const [rowSpan, colSpan, heightSpan] = validateGridSpan(normalizedMetadata);
    const choiceInfo = {
      id: choice?.id,
      visualizerType: getTypeNameBySpan([rowSpan, colSpan, heightSpan]),
      productType: normalizedMetadata?.ProductType?.value || 'default',
      span: [rowSpan, colSpan, heightSpan],
      size: `${rowSpan}x${colSpan}`,
    };

    // Add inclusiveChoices to choiceInfo only if it exists in the metadata.
    if (normalizedMetadata?.InclusiveChoices?.value) {
      choiceInfo.inclusiveChoices = normalizedMetadata.InclusiveChoices.value;
    }

    return choiceInfo;
  });

  return _keyBy(choicesVisualizerInfo, 'id');
};
